import styles from './DescriptionTerm.module.css'

const DescriptionTerm = ({ children }): JSX.Element => {
	return <dt className={styles.descriptionTerm}>{children}</dt>
}

export default DescriptionTerm
